import { Link } from "react-router-dom";
import ProfileContainer from "../components/ProfileContainer";
import UserImageCircle from "../../../components/UserImageCircle";
import React, { useState } from "react";
import InfoTooltip from "../../../components/InfoTooltip";
import { Typography } from "antd";
import { useLocation } from "react-use";
import TalentDisplayName from "../../../components/TalentDisplayName";

const { Text } = Typography;
const MAX_ROLES_VISIBLE = 5;

const ProfileMember = ({ member, className = '', ...props }) => {
    const location = useLocation();
    const profileLink = {
        ...location,
        pathname: `../talent-profiles/${member.id}`,
    };
    const scoringOptions = laravel.talent_scoring_options;

    const [allDisciplines, setAllDisciplines] = useState(() => member.talent_disciplines || member.disciplines || [])
    const [visibleTalentDisciplines] = useState(() => TB.slice(allDisciplines, 0, MAX_ROLES_VISIBLE));
    return (
        <div className={TB.mapClass("min-h-80 bg-[#F5F6F8] px-4 py-3 self-stretch flex flex-col justify-between gap-6", { [className]: true })}>
            <div className="flex flex-row items-center gap-4">

                <div className="relative transition-[width] delay-150">
                    <UserImageCircle
                        className="img-grayscale mx-auto img-fluid transition-all"
                        user={member}
                        hideTooltip
                        size={112} />
                </div>

                <div className="flex flex-col items-start justify-between gap-1">

                    <TalentDisplayName talent={member}>
                        <p className="text-lg font-bold whitespace-nowrap">
                            {member.firstNamePlusInitial()}
                        </p>
                    </TalentDisplayName>



                    <div className="relative overflow-hidden">
                        <Text type="secondary"
                            className="text-xs text-ellipsis line-clamp-2">{member.job_title}</Text>
                    </div>

                    {member.location && (
                        <div className="flex items-center my-1 gap-2">
                            <i className="fas fa-map-marker-alt" />
                            <p className="text-xs leading-4 text-wrippleBlueGray">{member.location.city}{!!member.location.state && `, ${member.location.state}`}</p>
                        </div>
                    )}

                    <div className="relative flex flex-col items-start gap-1">
                        {/*<div>*/}
                        {/*    <div id="commitment-level"*/}
                        {/*         className="mt-auto py-1 px-2.5 inline-block bg-wripplePrimaryRuleBlue cursor-default">*/}
                        {/*        <p className="text-xs">{CommitmentOptions[member.talent_commitment_level]?.title}</p>*/}
                        {/*    </div>*/}

                        {/*    <InfoTooltip target="commitment-level" type="dark" placement="bottom">*/}
                        {/*        <p className="text-white p-0 text-xs">*/}
                        {/*            {CommitmentOptions[member.talent_commitment_level]?.description}*/}
                        {/*        </p>*/}
                        {/*    </InfoTooltip>*/}
                        {/*</div>*/}
                        {(member.displayed_resume_path || member.linkedin_profile_url) && (
                            <div>
                                <div className="flex gap-2.5 items-center flex-row justifycenter">
                                    {member.linkedin_profile_url && (
                                        <a href={member.linkedin_profile_url} id="pl-linkedin" target="_blank">
                                            <i className="fab fa-linkedin text-xl" />
                                        </a>
                                    )}
                                    {member.displayed_resume_path && (
                                        <a href={member.displayed_resume_path} id="pl-resume" target="_blank">
                                            <i className="fas fa-file-alt text-xl" />
                                        </a>
                                    )}
                                </div>
                                {member.linkedin_profile_url && (
                                    <InfoTooltip target="pl-linkedin" type="dark" placement="bottom">
                                        <p className="text-white p-0">
                                            Visit LinkedIn Profile
                                        </p>
                                    </InfoTooltip>
                                )}
                                {member.displayed_resume_path && (
                                    <InfoTooltip target="pl-resume" type="dark" placement="bottom">
                                        <p className="text-white p-0">
                                            Download Resume
                                        </p>
                                    </InfoTooltip>
                                )}
                            </div>
                        )}
                    </div>
                </div>


            </div>
            {/*<div className="rich-text-display">*/}
            {/*    <ExpandableHtmlText content={TB.stripHtml(member.bio)?.length > 0 ?*/}
            {/*        member.bio : '<i>No Description Provided</i>'*/}
            {/*    } maxHeight={120}/>*/}
            {/*</div>*/}
            <div className="flex gap-4 flex-wrap items-start">
                {TB.map(visibleTalentDisciplines, discipline => (
                    <div key={discipline.id}
                        className="flex flex-col items-center justify-center text-center max-w-2/3 border border-secondary rounded-lg p-2 pb-1">
                        <p className="text-xs font-bold text-ellipsis line-clamp-2">{discipline.name}</p>
                        <p className="text-xxs text-[#3E3F42]">{scoringOptions[discipline.self_score]}</p>

                    </div>
                ))}


                {(allDisciplines?.length - MAX_ROLES_VISIBLE) > 0 && (
                    <p
                        className="text-center border border-secondary flex items-center justify-center rounded-lg py-2 px-5"
                    >
                        <span className="text-xs font-bold line-clamp-2 text-ellipsis">+ {allDisciplines.length - MAX_ROLES_VISIBLE}</span>
                    </p>
                )}
            </div>
            <Link className="mt-auto btn btn-primary" to={profileLink}>
                View Profile
            </Link>
        </div>
    )
}
const MAX_MEMBERS_LENGTH = 4;
const TalentProfileMembers = ({ items = {} }) => {
    const FEATURED_COUNT = 3;

    const [isAllMembersOpen, setIsAllMembersOpen] = useState(false);
    let filteredMembers = TB.differenceBy(items?.members || [], items.featuredMembers || [], 'id');

    // if featuredMembers length exists and is less than FEATURED_COUNT, add from members up to FEATURED_COUNT by display_index
    if (items.featuredMembers?.length && items.featuredMembers?.length < FEATURED_COUNT) {
        const sortedFilteredMembers = TB.sortBy(filteredMembers, 'display_index');
        items.featuredMembers.push(...sortedFilteredMembers.slice(0, FEATURED_COUNT - items.featuredMembers?.length))
        filteredMembers = TB.differenceBy(filteredMembers, items.featuredMembers, 'id');
    }

    return (
        <div id="individuals" className="pt-2 pb-8">
            <ProfileContainer>
                <div>
                    <h4 className="text-bold font-xl pb-6">Team Members</h4>

                    <div className="flex flex-col relative items-stretch gap-6">
                        {!!items.featuredMembers?.length && (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {TB.map(items.featuredMembers || [], member => (
                                    <ProfileMember member={member} key={'member-' + member.id} />
                                ))}
                            </div>
                        )}

                        {!!items.featuredMembers?.length && !!filteredMembers?.length && (
                            <div>
                                <p className="section-title">Other Members</p>
                            </div>
                        )}

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {filteredMembers?.length > 0 && filteredMembers.slice(0, isAllMembersOpen ? filteredMembers.length : MAX_MEMBERS_LENGTH)?.map((member, index) => (
                                <ProfileMember member={member} key={'member-' + member.id} />
                            ))}
                        </div>
                        {filteredMembers?.length > MAX_MEMBERS_LENGTH && (
                            <div className="pt-6 flex justify-end">
                                <button
                                    type="button"
                                    className="btn-outline flex items-center gap-2 p-1.5 px-2.5 transition hover:bg-wrippleOffWhite"
                                    onClick={() => setIsAllMembersOpen(!isAllMembersOpen)}
                                >
                                    <p>{filteredMembers.length - MAX_MEMBERS_LENGTH} {isAllMembersOpen ? 'less' : 'more'}</p>
                                    <div className="bg-wrippleOffWhite h-6 w-6 shrink-0 flex items-center justify-center">
                                        <i className={TB.mapClass("fa fa-chevron-down transition text-base", { 'rotate-180': isAllMembersOpen })} />
                                    </div>
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </ProfileContainer>
        </div>
    )
}

export default TalentProfileMembers;